import { Calendar, Record, RecordCircle } from 'iconsax-react';
import React, { useEffect, useState } from 'react'
import { DateRange } from 'react-date-range';
import { Calendar as CalendarNew } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import './Assets/styles.css'
import { useLocation } from 'react-router-dom'


const FlightsDateGoing = ({ setOneWay, oneWay, setRoundTrip, roundTrip,setDateGoing,dateGoing, cardRef, setDateGoingSelected, setDateGoingSelectedApi, setDateSreturnSelected, setDateSreturnSelectedApi }) => {

  const [fecha, setFecha] = useState(0)
  const date = new Date()
  date.setDate(date.getDate() + 1);

  const location = useLocation()

  const position = location.pathname.split('/')[1]

  const dateMax = new Date()
  dateMax.setDate(date.getDate() + 360);

  const [startDate, setStartDate] = useState(new Date())
  const [endDate, setEndDate] = useState(new Date())
  const [aaa, setAaa] = useState(false)
  const [dateOneWay, setDateOneWay] = useState(new Date())


  const selectionRange = {
    startDate: startDate,
    endDate: endDate,
    aaa: aaa,
    key: 'selection'
  }

  const hiddenM = ()=> {
    setDateGoing(!dateGoing)
  }

  useEffect(() => {
    setFecha(fecha)
  }, [fecha])

  {/*  CHECK BOX */ }
  const changeRoundTrip = () => {
    setOneWay(false)
    setRoundTrip(true)
    /*  roundTrip === false && oneWay=== true ? console.log('ida y vuelta') : console.log(' solo ida ') */
  }
  {/*  CHECK BOX */ }
  const changeOneWay = () => {
    setOneWay(true)
    setRoundTrip(false)
    /*   roundTrip === true && oneWay=== false ? console.log(' solo ida ') : console.log(' ida y vuelta ') */
  }

  let diaS = 0

  const handleSelect = (ranges) => {

    setStartDate(ranges.selection.startDate)

    setDateGoingSelected(ranges.selection.startDate.toLocaleDateString('en-us', { year: "numeric", month: "short", day: "numeric" }))

    setDateGoingSelectedApi(ranges.selection.startDate.toISOString('en-us', { year: "numeric", month: "short", day: "numeric" }))
    setAaa(!ranges.selection.aaa)
    setEndDate(ranges.selection.endDate)

    setFecha(calcularDiasEntreFechas(ranges.selection.startDate.toLocaleDateString('en-us', { year: "numeric", month: "numeric", day: "numeric" }), ranges.selection.endDate.toLocaleDateString('en-us', { year: "numeric", month: "numeric", day: "numeric" })))

    setDateSreturnSelected(ranges.selection.endDate.toLocaleDateString('en-us', { year: "numeric", month: "short", day: "numeric" }))
    setDateSreturnSelectedApi(ranges.selection.endDate.toISOString('en-us', { year: "numeric", month: "short", day: "numeric" }))
  }

  const onChangeOnlyDate = (item) => {
    setDateOneWay(item)
    setDateGoingSelected(item.toLocaleDateString('en-us', { year: "numeric", month: "short", day: "numeric" }))
    setDateGoingSelectedApi(item.toISOString('en-us', { year: "numeric", month: "short", day: "numeric" }))
  }



  function calcularDiasEntreFechas(fechaInicio, fechaFin) {
    const unDiaEnMilisegundos = 1000 * 60 * 60 * 24; // 1 día en milisegundos
    const fechaInicioObj = new Date(fechaInicio);
    const fechaFinObj = new Date(fechaFin);
    const diferenciaEnMilisegundos = fechaFinObj - fechaInicioObj;
    const diasDeDiferencia = Math.round(diferenciaEnMilisegundos / unDiaEnMilisegundos);
    return diasDeDiferencia;
  }






  return (
    <div className='flightsDateGoing_container' ref={cardRef}>
      {oneWay ?
        <div className='flightsDateGoing'>
          <div className='flightsDateGoing_'>
            <div className='flightsDateGoing_date' style={{ border: '1px solid #004274' }}>
              <div className='flightsDateGoing_date_'>
                <div>
                  <h2>ida</h2>
                  <p style={{color:'black'}}>{dateOneWay.toLocaleDateString('en-us', { year: "numeric", month: "short", day: "numeric" })}</p>
                </div>
                <div className='icons-cale'>
                  <Calendar size="28" color="#004274" />
                </div>
              </div>
            </div>
            <div className={position === "fligths" ? 'flightsHeaderFind_checkBox-c' : 'flightsHeaderFind_checkBox'}>
              <div className='flightsHeaderFind_checkBoxOne'>
                <div onClick={changeRoundTrip}>
                  {roundTrip ?
                    <RecordCircle style={{ cursor: 'pointer' }} size="28" color="#004274" />
                    :
                    <Record style={{ cursor: 'pointer' }} size="28" color="#004274" />
                  }
                </div>
                <p>Ida y vuelta</p>
              </div>
              <div className='flightsHeaderFind_checkBoxOne'>
                <div onClick={changeOneWay}>
                  {oneWay ?
                    <RecordCircle style={{ cursor: 'pointer' }} size="28" color="#004274" />
                    :
                    <Record style={{ cursor: 'pointer' }} size="28" color="#004274" />
                  }
                </div>
                <p>Solo ida</p>
              </div>
            </div>

          </div>
          <div className='dateRangeOnly'>
            <CalendarNew minDate={date} maxDate={dateMax} editableDateInputs={true} months={2} direction="horizontal" onChange={onChangeOnlyDate} date={dateOneWay} />
            <div className='contain-btn-select-f'>
              <button onClick={hiddenM}>Seleccionar vuelo escogido</button>
            </div>
          </div>

        </div>
        :
        <div className='flightsDateGoing'>
          <div className='flightsDateGoing_'>
            {aaa ?
              <div className='flightsDateGoing_date' style={{ border: '1px solid #004274', backgroundColor: "#004274", color: "#ffff" }}>
                <div className='flightsDateGoing_date_'>
                  <div>
                    <h2 style={{ color: "#ffff" }}>ida</h2>
                    <p >{startDate.toLocaleDateString('en-us', { year: "numeric", month: "short", day: "numeric" })}</p>
                  </div>
                  <div className='icons-cale'>
                    <Calendar size="28" color="#ffff" />
                  </div>
                </div>
              </div>
              :
              <div className='flightsDateGoing_date'>
                <div className='flightsDateGoing_date_'>
                  <div>
                    <h2 >ida</h2>
                    <p style={{color:'black'}}>{startDate.toLocaleDateString('en-us', { year: "numeric", month: "short", day: "numeric" })}</p>
                  </div>
                  <div className='icons-cale'>
                    <Calendar size="28" color="#004274" />
                  </div>
                </div>
              </div>
            }
            {!aaa ?
              <div className='flightsDateGoing_date' style={{ border: '1px solid #004274', backgroundColor: "#004274", color: "#ffff" }}>
                <div className='flightsDateGoing_date_'>
                  <div>
                    <h2 style={{ color: "#ffff" }}>vuelta</h2>
                    <p>{endDate.toLocaleDateString('en-us', { year: "numeric", month: "short", day: "numeric" })}</p>
                  </div>
                  <div className='icons-cale'>
                    <Calendar size="28" color="#ffff" variant="Bold" />
                  </div>
                </div>
              </div>
              :
              <div className='flightsDateGoing_date'>
                <div className='flightsDateGoing_date_'>
                  <div>
                    <h2>vuelta</h2>
                    <p style={{color:'black'}}>{endDate.toLocaleDateString('en-us', { year: "numeric", month: "short", day: "numeric" })}</p>
                  </div>
                  <div className='icons-cale'>
                    <Calendar size="28" color="#004274" variant="Bold" />
                  </div>
                </div>
              </div>
            }
            <div className={position === "fligths" ? 'flightsHeaderFind_checkBox-c' : 'flightsHeaderFind_checkBox'}>
              <div className='flightsHeaderFind_checkBoxOne'>
                <div onClick={changeRoundTrip}>
                  {roundTrip ?
                    <RecordCircle style={{ cursor: 'pointer' }} size="28" color="#004274" />
                    :
                    <Record style={{ cursor: 'pointer' }} size="28" color="#004274" />
                  }
                </div>
                <p>Ida y vuelta</p>
              </div>
              <div className='flightsHeaderFind_checkBoxOne'>
                <div onClick={changeOneWay}>
                  {oneWay ?
                    <RecordCircle style={{ cursor: 'pointer' }} size="28" color="#004274" />
                    :
                    <Record style={{ cursor: 'pointer' }} size="28" color="#004274" />
                  }
                </div>
                <p>Solo ida</p>
              </div>
            </div>
          </div>
          <div className='dateRange'>
            <DateRange minDate={date} maxDate={dateMax} editableDateInputs={true} onChange={handleSelect} moveRangeOnFirstSelection={false} ranges={[selectionRange]} months={2} direction="horizontal" />
            <div className='contain-btn-select-f'>
              <button onClick={hiddenM}>Seleccionar vuelo de {fecha} dias</button>
            </div>
          </div>
        </div>
      }
    </div>
  )
}

export default FlightsDateGoing